import React from "react";
import type {VoidFunctionComponent} from "react";
import {FilterSortColumns} from "../filter-sort-columns/FilterSortColumns";
import {FilterSortDirection} from "../filter-sort-direction/FilterSortDirection";

export const FilterSort: VoidFunctionComponent = () => {
  return (
    <>
      <FilterSortColumns/>
      <FilterSortDirection/>
    </>
  );
}
